// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Kw7\\+[data-v-d0c46ff4]{margin-bottom:16px;font-size:15px;font-style:normal;font-weight:400;text-align:left}.Kw7\\+[data-v-d0c46ff4],._4kJQ[data-v-d0c46ff4]{display:flex;line-height:20px;letter-spacing:-.23px}._4kJQ[data-v-d0c46ff4]{flex-grow:0;flex-shrink:0;align-items:center;justify-content:center;width:24px;height:24px;margin-right:12px;border:1px solid #000;border-radius:50%;font-size:13px;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "Kw7+",
	"comp__number": "_4kJQ"
};
module.exports = ___CSS_LOADER_EXPORT___;
